/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const membershipCreateBodyUserIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const membershipCreateBodyExpectedTeamVersionExclusiveMin = 0;
export const membershipCreateBodyExpectedTeamVersionMax = 9007199254740991;

export const MembershipCreateBody = zod.object({
  userId: zod.uuid().regex(membershipCreateBodyUserIdRegExp),
  expectedTeamVersion: zod
    .int()
    .gt(membershipCreateBodyExpectedTeamVersionExclusiveMin)
    .max(membershipCreateBodyExpectedTeamVersionMax),
});

export type MembershipCreateBody = zod.input<typeof MembershipCreateBody>;
export type MembershipCreateBodyOutput = zod.output<typeof MembershipCreateBody>;
